module.exports = __webpack_public_path__ + "img/project-1.d18f3939.jpg";